"use client";
import { useState } from "react";
import Image from "next/image";
import { Card, CardContent } from "@/components/hongkong-setup-v2/ui/card";
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, Navigation, FreeMode } from "swiper/modules";
import { useSwiperEarlyDestroy } from "@/hooks/use-swiper-early-destroy";

// Swiper modules (default exports now)

// Swiper styles


const employeeData = [
  {
    name: "Employee Name",
    title: "Airwallex Support Coordinator",
    image: "/hongkong-setup-v2/AirwallexSupportCoordinator.png",
  },
  {
    name: "Employee Name",
    title: "Airwallex Support Coordinator",
    image: "/hongkong-setup-v2/AirwallexSupportCoordinator1.png",
  },
  {
    name: "Employee Name",
    title: "Airwallex Support Coordinator",
    image: "/hongkong-setup-v2/AirwallexSupportCoordinator3.png",
  },
  // {
  //   name: "Employee Name",
  //   title: "Airwallex Support Coordinator",
  //   image: "/hongkong-setup-v2/AirwallexSupportCoordinator5.png",
  // },
  // {
  //   title: "Airwallex Support Coordinator",
  //   image: "/hongkong-setup-v2/AirwallexSupportCoordinator10.png",
  // },
  {
    title: "Airwallex Support Coordinator",
    image: "/hongkong-setup-v2/AirwallexSupportCoordinator11.png",
  },
  {
    title: "Airwallex Support Coordinator",
    image: "/hongkong-setup-v2/AirwallexSupportCoordinator14.png",
  },
  {
    title: "Banking Support Coordinator",
    image: "/hongkong-setup-v2/BankingSupportCoordinator.png",
  },
  {
    title: "Banking Support Coordinator",
    image: "/hongkong-setup-v2/BankingSupportCoordinator1.png",
  },
  {
    title: "Banking Support Coordinator",
    image: "/hongkong-setup-v2/BankingSupportCoordinator2.png",
  },
  {
    title: "Company Registration Specialist",
    image: "/hongkong-setup-v2/CompanyRegistrationSpecialist.png",
  },
  // {
  //  title: "Company Registration Specialist",
  //   image: "/hongkong-setup-v2/CompanyRegistrationSpecialist2.png",
  // },
  {
    title: "Customer Success Assistant",
    image: "/hongkong-setup-v2/CustomerSuccessAssistant15.png",
  },
    {
    title: "PayPal Support Coordinator",
    image: "/hongkong-setup-v2/PayPalSupportCoordinator.png",
  },
     {
    title: "PayPal Support Coordinator",
    image: "/hongkong-setup-v2/PayPalSupportCoordinator8.png",
  },
     {
    title: "PayPal Support Coordinator",
    image: "/hongkong-setup-v2/PayPalSupportCoordinator15.png",
  },
];

export const ComponentNodeSection = () => {
  const [hoveredIndex, setHoveredIndex] = useState<number | null>(null);
  const { onSwiper } = useSwiperEarlyDestroy();

  return (
    <section className="flex flex-col items-center gap-[58px] w-full py-[40px] lg:py-[70px]">
      {/* Heading */}
      <div className="flex flex-col w-full max-w-[1315px]  gap-[19.31px]">
        <div className="flex flex-col items-center w-full">
          <h2 className="font-['SharpGroteskPeTrialBook-20',sans-serif]  font-normal sm:px-0 px-2 text-[32px] leading-[34px] sm:leading-[42px] md:leading-[50px] lg:leading-[58px] xl:leading-[120%] lg:text-[70px] text-center tracking-[-1.45px] ">
            <span className=" bg-gradient-to-r from-[rgba(21,93,252,1)] to-[rgba(255,255,255,1)] bg-clip-text text-transparent tracking-[-0.81px]">
              We Take You From Zero to a <br className="sm:block hidden"/>
              Fully{" "}
            </span>
            <span className="text-white font-normal tracking-[-0.81px]">
              Activated Hong Kong PSP
            </span>
          </h2>
        </div>
        <p className="max-w-[840px]  mx-auto flex flex-col items-center font-[300] text-zinc-400 md:text-[18px] text-md text-center tracking-[0] leading-6">
          A Hong Kong PSP setup is a compliance maze... strict rules, banking
          barriers, and hidden requirements that most entrepreneurs aren&apos;t prepared for.
        </p>
      </div>

      <h2 className="font-['SharpGroteskPeTrialBook-20',sans-serif] text-[26px] lg:text-[41px] text-center mx-10 leading-[64.9px] font-normal bg-[linear-gradient(138deg,rgba(21,93,252,1)_0%,#e2edff_100%)] [-webkit-background-clip:text] bg-clip-text [-webkit-text-fill-color:transparent] [text-fill-color:transparent]">
        Our Onboarding Team
      </h2>

      {/* Swiper Slider */}
      <div className="w-full max-w-[1440px] relative">
        <Swiper
          onSwiper={onSwiper}
          modules={[Navigation, Autoplay, FreeMode]}
          loop={true}
          autoplay={{
            delay: 0,
            disableOnInteraction: false,
            pauseOnMouseEnter: false
          }}
          speed={2000}
          freeMode={true}
          spaceBetween={20}
          slidesPerView={1}
          breakpoints={{
            640: { slidesPerView: 1 },
            768: { slidesPerView: 2 },
            1024: { slidesPerView: 4 },
          }}
        >
          {employeeData.map((employee, index) => (
            <SwiperSlide key={index}>
              <Card
                className="w-full h-[366px] bg-transparent border-0 overflow-hidden cursor-pointer"
                onMouseEnter={() => setHoveredIndex(index)}
                onMouseLeave={() => setHoveredIndex(null)}
              >
                <CardContent className="relative w-full h-full p-0">
                  <div className="relative w-full h-full overflow-hidden">
                    <Image                       className="w-full h-auto object-cover"
                      alt={employee.name || "Employee"}
                      src={employee.image}
                    width={800} height={600} />
                    <div
                      className={`absolute inset-0 bg-gradient-to-t from-black/60 to-transparent transition-opacity duration-300 ${
                        hoveredIndex === index ? "opacity-100" : "opacity-0"
                      }`}
                    />
                  {/* Overlay (desktop only) */}
<div
  className={`absolute inset-0 bg-gradient-to-t from-black/60 to-transparent 
  transition-opacity duration-300 
  hidden md:block 
  ${hoveredIndex === index ? "opacity-100" : "opacity-0"}`}
></div>

{/* Title */}
<div
  className={`absolute bottom-0 left-0 right-0 p-[8px] transition-all duration-300  
  opacity-100 translate-y-0 
  ${hoveredIndex === index ? "md:opacity-100 md:translate-y-0" : "md:opacity-0 md:translate-y-4"}`}
>
  <p className="font-inter bg-[linear-gradient(138deg,rgba(111,166,255,1)_0%,rgba(51,92,255,1)_100%)] 
    [-webkit-background-clip:text] bg-clip-text 
    [-webkit-text-fill-color:transparent] [text-fill-color:transparent] 
    text-center font-normal text-base tracking-[0] leading-[13.8px] whitespace-nowrap mt-2">
      {employee.title}
  </p>
</div>

                  </div>
                </CardContent>
              </Card>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </section>
  );
};
